<template>
  <button 
    type="button"
    data-test-id="quick-view-modal-trigger"
    class="absolute top-0 z-20 items-center justify-center flex opacity-0 w-full h-full from-black/80 bg-gradient-to-b to-black/30 group-hover:opacity-100 transition-opacity"
    @click="handleClick"
    @keydown.enter="handleClick"
  >
    <div
      class="btn btn--white btn--sm capitalize"
    >
      Quick View
      <span class="sr-only">for {{ title }}</span>
    </div>
  </button>
</template>

<script lang="ts">
export default { name: 'QuickViewModalTrigger' }
</script>

<script setup lang="ts">
import { useUiStore } from '~/store/modules/ui'

const props = defineProps<{
  url: string
  title: string
}>()

const { toggleQuickViewModal } = useUiStore()

const handleClick = () => {
  toggleQuickViewModal(props.url)
}
</script>
